import React, { useState, useReducer, useCallback, useEffect } from 'react';
import Select from 'react-select';

import { confService } from '../../Services';

import Loader from '../Common/Loader';

import {ReactComponent as Loading} from '../../images/icons/General/loading-01.svg';

const dataReducer = (state, event) => {
    if (event.action === 'clear')
        return {};
    else
        return {
            ...state,
            [event.key]: event.value
        };
};

export const OM = () => {
    const [info, setInfo] = useState({});
    const [data, setData] = useReducer(dataReducer, {});
    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [gear, setGear] = useState({});

    const customStyles = {
        container: (provided, state) => ({
            ...provided,
            flex: '1',
            height: '42px'
          }),
        control: (provided, state) => ({
          ...provided,
          border: '1px solid #D0D5DD',
          '&:hover': {
            boxShadow: '0 0 1px #5D3FC5'
          }
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    }

    const changeSelectValue = (name, value, selectSetVar) => {
        selectSetVar(value);
        setData({
            key: name,
            value: value ? value.value : '',
        });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        setError('');
        setSuccess(false);
        setLoading(true);

        const res = await confService.editOm(data);

        if (res.res === 'OK')
            setSuccess(true);
        else
            setError(res.error);

        setLoading(false);
    };

    const fetchData = useCallback(async () => {
        setPageLoading(true);

        const res = await confService.omInfo();

        if (res.error)
            setError(res.error);
        else {
            setInfo(res.info);

            Object.keys(res.data).forEach((key) => {
                switch (key) {
                    case 'gear':
                        setGear(res.info.gears.filter(item => item.value === res.data[key]));
                    break;

                    default:
                }

                setData({
                    key: key,
                    value: res.data[key]
                });
            });
        }

        setPageLoading(false);
      }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <>
            {pageLoading ? <Loader /> :
                <>
                    <h1>Organization settings</h1>
                    <form onSubmit={handleSubmit} className={error ? 'required' : ''} noValidate>
                        <div className="form-column">
                            <label>Default dive mode</label>
                            <Select
                                options={info.gears}
                                onChange={(value) => changeSelectValue('gear', value, setGear)}
                                styles={customStyles}
                                value={gear}
                                menuPortalTarget={document.body}
                                isClearable
                            />
                        </div>
                        <div className="form-submit">
                            <div><button type="submit" className="primary">{loading ? <Loading className="btn-loader" alt="loader" /> : ''}Save</button></div>
                            {error ? <div className="error">{error}</div> : ''}
                            {success ? <div className="success">Settings was successfully updated</div> : ''}
                        </div>
                    </form>
                </>
            }
        </>
    );
};

export default OM;
